import type { ThemeMode } from '../services/theme.service';

function prefersDarkColorScheme(): boolean {
	if (typeof globalThis.matchMedia !== 'function') {
		return false;
	}
	return globalThis.matchMedia('(prefers-color-scheme: dark)').matches;
}

/**
 * Resolves chart Highcharts palette / CSS from the component `themeMode` input.
 * Explicit `light` | `dark` wins so cards can pin appearance (e.g. AI Visibility)
 * without mutating global ThemeService. `auto` follows OS appearance, not app theme.
 */
export function resolveChartThemeMode(
	themeMode: ThemeMode,
	_activeThemeMode: 'light' | 'dark'
): 'light' | 'dark' {
	if (themeMode === 'light' || themeMode === 'dark') {
		return themeMode;
	}
	return prefersDarkColorScheme() ? 'dark' : 'light';
}

/**
 * When `themeMode` is pinned on the card (e.g. AI Visibility `light`), HTML
 * tooltips use inline colors instead of `:root` CSS vars. `auto` keeps legacy
 * report / editor behavior.
 */
export function explicitChartTooltipHtmlTheme(
	themeMode: ThemeMode
): 'light' | 'dark' | undefined {
	return themeMode === 'light' || themeMode === 'dark' ? themeMode : undefined;
}
